module.exports = __webpack_public_path__ + "static/hero-background-194c03f7f673fd065f2be25dcbd076ca.mp4";